import { createSelector } from "@reduxjs/toolkit";
import { RootState } from "../../../store/store";
import { ModalState } from "../../../entities/Modal";

export const getRoot = (state: RootState) => state.modal;

export const getModalData = createSelector(
  [getRoot],
  (modal: ModalState) => modal,
);
